<div class="notificationsPage">
  <div class="notifications-container">
      <div class="custom-container">
        <mat-card class="notifications-card">
          <mat-card-content>
            <h1>Control de Notificaciones</h1>
            <generic-table
              [columnHeader]="columnHeader"
              [service]="notificationCatalogService"
              [controllerName]="controllerName"
              [hasInactives]="hasInactives"
              [hasEditables]="hasEditables"
              [hasDeletables]="hasDeletables"
              [filterOptions]="filterOptions"
              [catalogPaginationRequest]="catalogPaginationRequest"
            >
            </generic-table>
          </mat-card-content>
        </mat-card>
      </div>
  </div>
</div>
